import { createAuth0Client } from '@auth0/auth0-spa-js';

const DOMAIN   = process.env.REACT_APP_AUTH0_DOMAIN;
const CLIENTID = process.env.REACT_APP_AUTH0_CLIENT_ID;
const AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE || 'https://api.valueguard.se';

console.log('Auth0 env check:', { DOMAIN, CLIENTID, AUDIENCE });
if (!DOMAIN || !CLIENTID) {
    console.error('❌ Missing REACT_APP_AUTH0_* env vars. Check your .env/.env.local and restart npm start.');
}


let auth0;

export async function getAuth0() {
    if (!auth0) {
        auth0 = await createAuth0Client({
            domain: DOMAIN,
            clientId: CLIENTID,
            authorizationParams: {
                audience: AUDIENCE,
                redirect_uri: window.location.origin,
                scope: 'openid profile email offline_access'
            },
            cacheLocation: 'localstorage',
            useRefreshTokens: true,
            useRefreshTokensFallback: true
        });
    }
    return auth0;
}

export async function handleAuthRedirectIfNeeded() {
    const a0 = await getAuth0();
    if (window.location.search.includes('code=') && window.location.search.includes('state=')) {
        await a0.handleRedirectCallback();
        window.history.replaceState({}, document.title, window.location.pathname);
    }
}

export async function getAccessToken() {
    const a0 = await getAuth0();
    return a0.getTokenSilently({ authorizationParams: { audience: AUDIENCE } });
}

export async function login() {
    const a0 = await getAuth0();
    await a0.loginWithRedirect();
}

export async function logout() {
    const a0 = await getAuth0();
    await a0.logout({ logoutParams: { returnTo: window.location.origin } });
}